import {isObject} from '@cullylarson/f'

// can provide a string, an array, or individual string arguments. e.g. classnames('my-class'), classnames(['my-class-1', 'my-class-2']), classnames('my-class-1', 'my-class-2')
export function classnames(...args) {
    if(!args.length) return ''

    const x = args.length === 1
        ? args[0]
        : args

    return !isObject(x)
        ? x
        : x.filter(x => !!x).join(' ')
}
